exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer[_v-ab0d84f4]{margin-top:1rem;margin-bottom:2rem;color:#cacaca;font-size:.9rem;text-align:center}.footer ul[_v-ab0d84f4]{margin-left:0;margin-bottom:.5rem}.footer ul li[_v-ab0d84f4]{display:inline-block;line-height:.8rem}.footer li+li[_v-ab0d84f4]{border-left:1px solid #ccc;padding-left:.5rem}.footer a[_v-ab0d84f4]{color:#cacaca;font-size:.9rem}.footer a[_v-ab0d84f4]:hover{color:#979797}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-ab0d84f4&scoped=true!./~/sass-loader?indentedSyntax!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Footer.vue
 ** module id = 40
 ** module chunks = 1
 **/